export default __webpack_public_path__ + "static/media/newChat.2f70d4ba.svg";